<template>
  <div class="select-num-people">
    <!-- 大人 -->
    <div class="select-num-people__wrap --adult">
      <p class="select-num-people__label">大人</p>
      <AppSelectNumber 
        :numbers="10"
        :value="selectedAdultHeadCnt"
        label="人"
        :paddingLeft="3.5"
        class="select-num-people__select"
        @inputed="setAdultLength"
      />
    </div>

    <!-- 子ども -->
    <div class="select-num-people__wrap --child">
      <ModalChildrenCount
        :exUpperGradesHeadCnt="selectedExUpperGradesHeadCnt"
        :exLowerGradesHeadCnt="selectedExLowerGradesHeadCnt"
        :youjiAHeadCnt="selectedYoujiAHeadCnt"
        :youjiBHeadCnt="selectedYoujiBHeadCnt"
        :youjiCHeadCnt="selectedYoujiCHeadCnt"
        :youjiDHeadCnt="selectedYoujiDHeadCnt"
        :scrollPointToLabel="100"
        @inputed="setChildrenLength"
      />      
    </div>    
  </div>
</template>

<script>
import AppSelectNumber from '@/components/elements/AppSelectNumber'
import ModalChildrenCount from '../ModalChildrenCount/'

export default {
  name: 'select-num-people',
  components: {
    AppSelectNumber,
    ModalChildrenCount
  },
  props: {
    adultHeadCnt: {
      type: [Number, String],
      required: false,
      default: 2
    }, // 大人の人数
    exUpperGradesHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 高学年
    exLowerGradesHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 低学年
    youjiAHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事・布団付き
    youjiBHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事のみ
    youjiCHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 布団のみ
    youjiDHeadCnt: {
      type: [Number, String],
      required: false,
      default: 0
    }, // 食事・布団不要
  },
  data() {
    return {
      selectedAdultHeadCnt: Number(this.adultHeadCnt),
      selectedExLowerGradesHeadCnt: Number(this.exLowerGradesHeadCnt),
      selectedExUpperGradesHeadCnt: Number(this.exUpperGradesHeadCnt),
      selectedYoujiAHeadCnt: Number(this.youjiAHeadCnt),
      selectedYoujiBHeadCnt: Number(this.youjiBHeadCnt),
      selectedYoujiCHeadCnt: Number(this.youjiCHeadCnt),
      selectedYoujiDHeadCnt: Number(this.youjiDHeadCnt),
    }
  },
  methods: {
    setAdultLength(value) {
      this.selectedAdultHeadCnt = value
      this.inputed()
    },
    setChildrenLength(list) {
      list.forEach(item => {
        if (item.id === 'exUpperGradesHeadCnt') this.selectedExUpperGradesHeadCnt = item.value
        if (item.id === 'exLowerGradesHeadCnt') this.selectedExLowerGradesHeadCnt = item.value
        if (item.id === 'youjiAHeadCnt') this.selectedYoujiAHeadCnt = item.value
        if (item.id === 'youjiBHeadCnt') this.selectedYoujiBHeadCnt = item.value
        if (item.id === 'youjiCHeadCnt') this.selectedYoujiCHeadCnt = item.value
        if (item.id === 'youjiDHeadCnt') this.selectedYoujiDHeadCnt = item.value
      })
      this.inputed()
    },
    inputed() {
      this.$emit('inputed', {
        adultHeadCnt: Number(this.selectedAdultHeadCnt) || 0,
        exUpperGradesHeadCnt: Number(this.selectedExUpperGradesHeadCnt) || 0,
        exLowerGradesHeadCnt: Number(this.selectedExLowerGradesHeadCnt) || 0,
        youjiAHeadCnt: Number(this.selectedYoujiAHeadCnt) || 0,
        youjiBHeadCnt: Number(this.selectedYoujiBHeadCnt) || 0,
        youjiCHeadCnt: Number(this.selectedYoujiCHeadCnt) || 0,
        youjiDHeadCnt: Number(this.selectedYoujiDHeadCnt) || 0,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.select-num-people {
  @include sp {
    align-items: center;
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    display: flex;
  }

  &__wrap {
    &.--adult,
    &.--child {
      border: 1px solid $cool-gray-3;
      border-radius: .25rem;
      height: 2.5rem;
      margin-bottom: .5rem;
      position: relative;
      width: 100%;

      @include sp {
        border: none;
        margin-bottom: 0;
        width: 50%;
      }
    }

    &.--adult {
      margin-right: 1px;

      @include sp {
        width: calc(50% - 1px);

        &::after {
          background-color: $cool-gray-3;
          content: '';
          display: block;
          mix-blend-mode: multiply;
          height: calc(2.5rem - 16px);
          position: absolute;
          right: -1px;
          top: 7px;
          width: 1px;
        }
      }
    }

    &.--child {
      margin-bottom: 0;
    }
  }

  &__label {
    align-items: center;
    display: flex;
    font-size: .875rem;
    height: 100%;
    left: 0;
    padding-left: .5rem;
    pointer-events: none;
    position: absolute;
    top: 0;
    user-select: none;
    z-index: 1;
  }

  &__select {
    @include focus {
      outline-offset: -1px;
    }
  }
}
</style>